exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-navi{width:100%;height:82px;border-bottom:.5px solid #d9d9d9;display:flex;align-items:center;justify-content:space-between;padding:0 20px;position:relative}.mock-noti-message{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.logo,.logo img{width:154.6px}.logo img{height:31px;object-fit:contain}.join{width:45px;margin-right:10px}.join,.login{height:19px;font-family:NanumBarunGothicUltraLightOTF;font-size:16px;font-weight:200;font-style:normal;font-stretch:normal;line-height:1.19;letter-spacing:normal;text-align:left;letter-spacing:5px;color:#000}.login{width:62px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-517e0372","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TopNavi.vue
// module id = 342
// module chunks = 0